/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const recordPlayInstallReferrerV1ResponseDataSchema = z.object({
  recorded: z.boolean(),
});

export type IRecordPlayInstallReferrerV1ResponseData = z.infer<
  typeof recordPlayInstallReferrerV1ResponseDataSchema
>;

export const recordPlayInstallReferrerV1ResponseSchema = createApiResponseSchema(
  recordPlayInstallReferrerV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IRecordPlayInstallReferrerV1ResponseData>>;

export type IRecordPlayInstallReferrerV1Response = IAPI<IRecordPlayInstallReferrerV1ResponseData>;
